import { User } from "@ecologi/shared";
import styled from "@emotion/styled";
import React from "react";
import { Button } from "../Button";
import WhiteLine from "@ecologi/assets/icons/white_line.svg";
import WhiteLineMobile from "@ecologi/assets/icons/white_line_2.svg";

type GreenBarProps = {
  user: User;
  text: string;
  buttonText: string;
};

export default function GreenBar({ user, text, buttonText }: GreenBarProps) {
  return (
    <Wrapper>
      <TextWrapper>
        <TitleWrapper>{user ? "You're ready to go" : text}</TitleWrapper>
      </TextWrapper>
      <WhiteLineMobileWrapper isUser={!!user} />
      <WhiteLineWrapper />
      <ButtonWrapper>
        <Button text={buttonText} href={"/impact-shop"} primary />
      </ButtonWrapper>
    </Wrapper>
  );
}

const WhiteLineWrapper = styled(WhiteLine)`
  display: block;
  @media ${(props) => props.theme.bp.mobileDown} {
    display: none;
  }
`;

const WhiteLineMobileWrapper = styled(WhiteLineMobile)<{ isUser: boolean }>`
  display: none;
  @media ${(props) => props.theme.bp.mobileDown} {
    display: block;
    position: absolute;
    right: ${(props) => (props.isUser ? "163px" : "257px")};
    top: 42px;
  }
`;

const Wrapper = styled.div`
  background: #035f48;
  width: 100%;
  height: 112px;

  position: sticky;
  top: calc(100vh - 112px);
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;

  @media ${(props) => props.theme.bp.tabletDown} {
    height: 100px;
    top: calc(100vh - 100px);
    gap: 10px;
  }
  @media ${(props) => props.theme.bp.mobileDown} {
    display: flex;
    flex-direction: column;
    gap: 10px;

    justify-content: center;
    align-items: center;

    height: 90px;
    top: calc(100vh - 90px);
  }
`;

const TextWrapper = styled.div`
  width: fit-content;
  margin-bottom: 5px;

  @media ${(props) => props.theme.bp.mobileDown} {
    position: absolute;
    left: 24px;
    top: 12px;
    font-size: 14px;
  }
`;

const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${(props) => props.theme.bp.tabletDown} {
    scale: 0.89;
  }

  @media ${(props) => props.theme.bp.mobileDown} {
    position: absolute;
    right: 14px;
    bottom: 14px;
    scale: 0.89;
  }
`;

const TitleWrapper = styled.h1`
  color: white;
  font-weight: 600;
  width: 100%;
  font-size: 32px;

  @media ${(props) => props.theme.bp.tabletDown} {
    font-size: 18px;
  }

  @media ${(props) => props.theme.bp.mobileDown} {
    font-size: 14px;
  }
`;
